"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessMessage = exports.MshopAddToCart = void 0;
const react_1 = __importStar(require("react"));
const axios_1 = __importDefault(require("axios"));
const lodash_1 = __importDefault(require("lodash"));
const monera_app_core_1 = require("@amzn/monera-app-core");
const metric_helper_1 = require("@amzn/monera-app-core/lib/utils/metric-helper");
const icons_1 = require("../icons");
const modal_1 = require("../modal");
const themed_text_1 = require("../themed-text");
const index_1 = require("./index");
const styles_1 = require("./styles");
const MshopAddToCart = ({ callToActionCart, quantity }) => {
    var _a;
    const [configStore, configStoreActions] = (0, monera_app_core_1.useConfigStore)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const [isSuccess, setIsSuccess] = (0, react_1.useState)(false);
    const [showToast, setShowToast] = (0, react_1.useState)(false);
    const { asin, addToCartCsrfToken, requestId } = configStore;
    const methodName = 'MshopAddToCart';
    const metricName = 'addToCart';
    (0, react_1.useEffect)(() => {
        const csrfTokenElement = document.getElementById(index_1.ADD_TO_CART_ID);
        if (csrfTokenElement != null && csrfTokenElement.value != null) {
            configStoreActions.update({ addToCartCsrfToken: csrfTokenElement.value });
        }
    }, []);
    const handleOnClick = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _b, _c;
        e.preventDefault();
        const csrfToken = addToCartCsrfToken !== null && addToCartCsrfToken !== void 0 ? addToCartCsrfToken : '';
        const formData = new URLSearchParams();
        formData.append('quantity', (quantity || 1).toString());
        formData.append('asin', asin);
        formData.append('items[0.base][quantity]', '1');
        formData.append('CSRF', csrfToken);
        formData.append('anti-csrftoken-a2z', csrfToken);
        formData.append('addToCart', '1');
        (_b = callToActionCart === null || callToActionCart === void 0 ? void 0 : callToActionCart.addToCart) === null || _b === void 0 ? void 0 : _b.data.parameters.forEach(({ name, value }) => {
            formData.append(name, value);
        });
        const headers = {
            'content-type': 'application/x-www-form-urlencoded',
            'anti-csrftoken-a2z': csrfToken
        };
        setIsLoading(true);
        try {
            const response = yield axios_1.default.post(((_c = callToActionCart === null || callToActionCart === void 0 ? void 0 : callToActionCart.addToCart) === null || _c === void 0 ? void 0 : _c.url) || '', formData, {
                headers
            });
            if (response.data.successful && response.data.count > 0) {
                setIsSuccess(true);
                setIsLoading(false);
                setShowToast(true);
                setTimeout(() => setShowToast(false), 2000);
                window.P.when('mash').execute((mash) => {
                    const cartDidUpdate = lodash_1.default.get(mash, 'cart.didUpdate');
                    lodash_1.default.isFunction(cartDidUpdate) && cartDidUpdate({ newCartQuantity: parseInt(response.data.count) });
                });
                (0, metric_helper_1.meterFatals)({
                    methodName,
                    metricName,
                    success: true,
                    requestId
                });
            }
            else {
                (0, metric_helper_1.meterFatals)({
                    methodName,
                    metricName,
                    error: true,
                    requestId
                });
                setIsSuccess(false);
                setIsLoading(false);
                setShowToast(true);
                setTimeout(() => setShowToast(false), 2000);
            }
        }
        catch (e) {
            (0, metric_helper_1.meterFatals)({
                methodName,
                metricName,
                fault: true,
                requestId
            });
            setIsSuccess(false);
            setIsLoading(false);
            setShowToast(true);
            setTimeout(() => setShowToast(false), 2000);
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.StyledForm, { onSubmit: handleOnClick },
            addToCartCsrfToken ? (react_1.default.createElement("input", { name: "anti-csrftoken-a2z", type: "hidden", value: addToCartCsrfToken })) : (react_1.default.createElement(index_1.AmznAntiCsrf, null)),
            react_1.default.createElement(styles_1.FullWidthButton, { buttonType: "primary", type: "submit" }, isLoading ? '' : (_a = callToActionCart === null || callToActionCart === void 0 ? void 0 : callToActionCart.addToCart) === null || _a === void 0 ? void 0 : _a.data.displayString),
            react_1.default.createElement(modal_1.Modal, { isOpen: showToast, close: () => setShowToast(false) },
                react_1.default.createElement(styles_1.StyledToast, null, isSuccess ? (react_1.default.createElement(exports.SuccessMessage, { message: callToActionCart === null || callToActionCart === void 0 ? void 0 : callToActionCart.addToCartSuccessMessage })) : (callToActionCart === null || callToActionCart === void 0 ? void 0 : callToActionCart.addToCartFailedMessage))))));
};
exports.MshopAddToCart = MshopAddToCart;
const SuccessMessage = ({ message }) => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement(icons_1.RioAlertIcon, { alertType: "success" }),
    react_1.default.createElement(themed_text_1.ThemedSpan, { color: "base", font: "base" }, message)));
exports.SuccessMessage = SuccessMessage;
